/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResistanceItem
 */
export interface ResistanceItem {
    /**
     * 
     * @type {string}
     * @memberof ResistanceItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ResistanceItem
     */
    name: string;
}

/**
 * Check if a given object implements the ResistanceItem interface.
 */
export function instanceOfResistanceItem(value: object): value is ResistanceItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ResistanceItemFromJSON(json: any): ResistanceItem {
    return ResistanceItemFromJSONTyped(json, false);
}

export function ResistanceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResistanceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ResistanceItemToJSON(json: any): ResistanceItem {
    return ResistanceItemToJSONTyped(json, false);
}

export function ResistanceItemToJSONTyped(value?: ResistanceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

